import React from 'react';
import { Message } from 'oskari-ui';
/**
 * @class Oskari.mapframework.bundle.coordinatetool.CoordinateToolBundleInstance
 *
 * Registers and starts the
 * Oskari.mapframework.bundle.coordinatetool.plugin.CoordinatesPlugin plugin for main map.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.coordinatetool.CoordinateToolBundleInstance',
/**
 * @method create called automatically on construction
 * @static
 */

function () {
  this.sandbox = null;
  this.started = false;
  this._localization = null;
  this.coordinateToolService = undefined;
}, {
  __name: 'coordinatetool',
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * Needed by sandbox.register()
   */
  init: function init() {},
  /**
   * @method setSandbox
   * @param {Oskari.Sandbox} sandbox
   * Sets the sandbox reference to this component
   */
  setSandbox: function setSandbox(sbx) {
    this.sandbox = sbx;
  },
  /**
   * @method getSandbox
   * @return {Oskari.Sandbox}
   */
  getSandbox: function getSandbox() {
    return this.sandbox;
  },
  /**
   * @method update
   * implements BundleInstance protocol update method - does nothing atm
   */
  update: function update() {},
  /**
   * @method getLocalization
   * Returns JSON presentation of bundles localization data for
   * current language.
   * If key-parameter is not given, returns the whole localization
   * data.
   *
   * @param {String} key (optional) if given, returns the value for
   *         key
   * @return {String/Object} returns single localization string or
   *      JSON object for complete data depending on localization
   *      structure and if parameter key is given
   */
  getLocalization: function getLocalization(key) {
    if (!this._localization) {
      this._localization = Oskari.getLocalization(this.getName());
    }
    if (key) {
      return this._localization[key];
    }
    return this._localization;
  },
  /**
   * @method start
   * implements BundleInstance protocol start methdod
   */
  start: function start() {
    var me = this;
    if (me.started) {
      return;
    }
    me.started = true;
    var conf = me.conf || {},
      sandboxName = (conf ? conf.sandbox : null) || 'sandbox',
      sandbox = Oskari.getSandbox(sandboxName);
    me.setSandbox(sandbox);
    var mapModule = sandbox.findRegisteredModuleInstance('MainMapModule');
    var plugin = Oskari.clazz.create('Oskari.mapframework.bundle.coordinatetool.plugin.CoordinateToolPlugin', conf, this);
    mapModule.registerPlugin(plugin);
    mapModule.startPlugin(plugin);
    this.plugin = plugin;
    sandbox.register(me);
    this._registerForGuidedTour();
  },
  /**
   * @method  @public isOpen
   * @return {Boolean} is popup open
   */
  isOpen: function isOpen() {
    var me = this;
    return me.plugin ? me.plugin.isOpen() : false;
  },
  /**
   * @public @method showMessage
   * Shows user a message with ok button
   *
   * @param {String} title popup title
   * @param {String} message popup message
   *
   */
  showMessage: function showMessage(title, message) {
    var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    dialog.show(title, message);
    dialog.fadeout(5000);
  },
  /**
   * @method update
   * implements BundleInstance protocol update method - does nothing atm
   */
  stop: function stop() {
    this.sandbox = null;
    this.started = false;
  },
  /**
   * @static
   * @property __guidedTourDelegateTemplate
   * Delegate object given to guided tour bundle instance. Handles content & actions of guided tour popup.
   * Function "this" context is bound to bundle instance
   */
  __guidedTourDelegateTemplate: {
    priority: 120,
    show: function show() {
      this.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'attach', this.__name]);
    },
    hide: function hide() {
      this.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'close', this.__name]);
    },
    getTitle: function getTitle() {
      return this.getLocalization().guidedTour.title;
    },
    getContent: function getContent() {
      return /*#__PURE__*/React.createElement(Message, {
        bundleKey: this.getName(),
        messageKey: "guidedTour.message",
        allowHTML: true
      });
    },
    getPositionRef: function getPositionRef() {
      return jQuery('.coordinatetool');
    },
    positionAlign: 'left',
    getLinks: function getLinks() {
      var _this = this;
      var me = this;
      var loc = this.getLocalization().guidedTour;
      return [{
        title: loc.openLink,
        onClick: function onClick() {
          return me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'attach', _this.__name]);
        },
        visible: false
      }, {
        title: loc.closeLink,
        onClick: function onClick() {
          return me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'close', _this.__name]);
        },
        visible: true
      }];
    }
  },
  /**
   * @method _registerForGuidedTour
   * Registers bundle for guided tour help functionality. Waits for guided tour load if not found
   */
  _registerForGuidedTour: function _registerForGuidedTour() {
    var me = this;
    function sendRegister() {
      var requestBuilder = Oskari.requestBuilder('Guidedtour.AddToGuidedTourRequest');
      if (requestBuilder && me.sandbox.hasHandler('Guidedtour.AddToGuidedTourRequest')) {
        var delegate = {
          bundleName: me.getName()
        };
        for (var prop in me.__guidedTourDelegateTemplate) {
          if (typeof me.__guidedTourDelegateTemplate[prop] === 'function') {
            delegate[prop] = me.__guidedTourDelegateTemplate[prop].bind(me); // bind methods to bundle instance
          } else {
            delegate[prop] = me.__guidedTourDelegateTemplate[prop]; // assign values
          }
        }
        me.sandbox.request(me, requestBuilder(delegate));
      }
    }
    function handler(msg) {
      if (msg.id === 'guidedtour') {
        sendRegister();
      }
    }
    var tourInstance = me.sandbox.findRegisteredModuleInstance('GuidedTour');
    if (tourInstance) {
      sendRegister();
    } else {
      Oskari.on('bundle.start', handler);
    }
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  protocol: ['Oskari.bundle.BundleInstance', 'Oskari.mapframework.module.Module']
});